
import { mapGetters, mapActions } from 'vuex'

export const editDialogValidation = {
	data() {
		return {          
      datePickerMenu1: false,
      datePickerMenu2: false,
      datePickerMenu3: false,
      dialogLoading: false,
      dom_haul_show: false,
      int_ship_show: false,  
      entry: {},        
    }
  },    
	methods: {      
    getGradeMaterialList(id) {
			return this.getGradeList.filter(x => x.material_id === id)
    },
    contaminationPerc2Dec(item) {
      if(item.cont_perc && !isNaN(item.cont_perc)) {
        item.cont_perc = parseFloat(item.cont_perc).toFixed(2)
      }  
    },
    materialVolume2Dec(item) {
      if(item.material_volume && !isNaN(item.material_volume)) {
        item.material_volume = parseFloat(item.material_volume).toFixed(2)
        if (!item.material_uom) {
          item.material_uom = this.getUser.default_uom
        }
      } else {
        item.material_uom = null
      }
    },
    price2Dec(item, field_cc, field) {
      if (item[field] && !isNaN(item[field])) {
        item[field] = parseFloat(item[field]).toFixed(2)
        if (!item[field_cc]) {
          item[field_cc] = this.getUser.default_cc
        } 
      } else {
        item[field] = null
        item[field_cc] = null
      }
    },
    price2Empty(item, field) {
      if(!item[field]) {
        item[field] = ''
      }       
    },
    getCountryByCode(code) {
			return this.getCountryList.find(x => x.code === code)
    },
    getHaulageCompanyCalcItem(item) {
      if (item.entry_type_id) {
        return this.getDomesticCompanyList.filter(x => x.entry_type_id === item.entry_type_id).map(x => { return x.dom_haul_company })
      } else {
        return this.getDomesticCompanyList.map(x => { return x.dom_haul_company })
      }
    },
    getShippingCompanyCalcItem(item) {
      if (item.entry_type_id) {
        return this.getShippingCompanyList.filter(x => x.entry_type_id === item.entry_type_id).map(x => { return x.int_ship_company })
      } else {
        return this.getShippingCompanyList.map(x => { return x.int_ship_company})
      }
    },
    getHs2ListCalcItem(item){
      if (item.entry_type_id) {
        return this.getHs2List.filter(x => x.entry_type_id === item.entry_type_id).map(x => { return x.hs2 })
      } else {
        return this.getHs2List.map(x => { return x.hs2 })
      }
    },
    getInspectionCompanyCalcItem(item) {
      if (item.entry_type_id) {
        return this.getInspectionCompanyList.filter(x => x.entry_type_id === item.entry_type_id).map(x => { return x.insp_company })
      } else {
        return this.getInspectionCompanyList.map(x => {return x.insp_company})
      }
    },
    getCompanyListCalcItem(item) {
      if (item.entry_type_id) {
        return this.getCompanyList.filter(x => x.entry_type_id === item.entry_type_id).map(x => { return x.coll_dest_company })
      } else {
        return this.getCompanyList.map(x => { return x.coll_dest_company })
      }
    },
    getCompanyCountryCalcItem(item) {     
      if (item.entry_type_id && item.coll_dest_company) {
        const companyCountry = this.getCompanyList.filter(x => x.entry_type_id === item.entry_type_id && x.coll_dest_company === item.coll_dest_company).map(x => { return this.getCountryByCode(x.coll_dest_country) })
        
        if (companyCountry.length > 0) {
          const divider = {divider: true}
          return companyCountry.concat(divider, this.getCountryList)
        }
      }       
      return this.getCountryList
    },
    getCompanyCityCalcItem(item) {
      if (item.entry_type_id && item.coll_dest_company && item.coll_dest_country) {
        return this.getCompanyList.filter(x => x.entry_type_id === item.entry_type_id && x.coll_dest_company === item.coll_dest_company && x.coll_dest_country === item.coll_dest_country).map(x => { return x.coll_dest_city })
      }
    },
    getCompanyAddressCalcItem(item) {
      if (item.entry_type_id && item.coll_dest_company && item.coll_dest_country && item.coll_dest_city) { 
        return this.getCompanyList.filter(x => x.entry_type_id === item.entry_type_id && x.coll_dest_company === item.coll_dest_company && x.coll_dest_country === item.coll_dest_country && x.coll_dest_city === item.coll_dest_city).map(x => { return x.coll_dest_address })
      }
    },
    getCompanyContactCalcItem(item) {
      if (item.entry_type_id && item.coll_dest_company && item.coll_dest_address && item.coll_dest_city && item.coll_dest_address) {
        return this.getCompanyList.filter(x => x.entry_type_id === item.entry_type_id && x.coll_dest_company === item.coll_dest_company && x.coll_dest_country === item.coll_dest_country && x.coll_dest_city === item.coll_dest_city && x.coll_dest_address === item.coll_dest_address).map(x => { return x.coll_dest_contact_name })
      }
    },
    collDestCompanyChanged(item) {
      if (item.entry_type_id && item.coll_dest_company && this.getCompanyCountryCalcItem(item).length > 0) {
        item.coll_dest_country = this.getCompanyCountryCalcItem(item)[0].code 
      } else {
        item.coll_dest_country = null
      }
      this.collDestCountryChanged(item)
    },
    collDestCountryChanged(item) {
      if (item.entry_type_id && item.coll_dest_company && item.coll_dest_country && this.getCompanyCityCalcItem(item).length > 0) {
        item.coll_dest_city = this.getCompanyCityCalcItem(item)[0]
      } else {
        item.coll_dest_city = null
      }
      this.collDestCityChanged(item)
    },
    collDestCityChanged(item) {
      if (item.entry_type_id && item.coll_dest_company && item.coll_dest_country && item.coll_dest_city && this.getCompanyAddressCalcItem(item).length > 0) {
        item.coll_dest_address = this.getCompanyAddressCalcItem(item)[0]
      } else {
        item.coll_dest_address = null
      }
      this.collDestAddressChanged(item)
    },
    collDestAddressChanged(item) {
      if (item.entry_type_id && item.coll_dest_company && item.coll_dest_country && item.coll_dest_city && item.coll_dest_address && this.getCompanyContactCalcItem(item).length > 0) {
        item.coll_dest_contact_name = this.getCompanyContactCalcItem(item)[0]
      } else {
        item.coll_dest_contact_name = null
      }
      this.collDestContactNameChanged(item)
    },
    collDestContactNameChanged(item) {
      if (item.entry_type_id && item.coll_dest_company && item.coll_dest_country && item.coll_dest_city && item.coll_dest_address && item.coll_dest_contact_name) {
        const collDestContact = this.getCompanyList.filter(x => x.entry_type_id === item.entry_type_id && x.coll_dest_company === item.coll_dest_company && x.coll_dest_country === item.coll_dest_country && x.coll_dest_city === item.coll_dest_city && x.coll_dest_address === item.coll_dest_address && x.coll_dest_contact_name === item.coll_dest_contact_name)
        if (collDestContact.length > 0) {
          item.coll_dest_contact_tel = collDestContact[0].coll_dest_contact_tel
          item.coll_dest_contact_email = collDestContact[0].coll_dest_contact_email
        } else {
          item.coll_dest_contact_tel = null
          item.coll_dest_contact_email = null
        }
      } else {
        item.coll_dest_contact_tel = null
        item.coll_dest_contact_email = null
      }
    },

		...mapActions([
      'setRlEntryAddDialogView2',
      'setRlEditDialog',           
      'setRlAddDialog',
      'setRlEntryList',
      'setRlAddDialogList',
      'deleteRlAddDialogList',
      'setRlImageAddDialog',
      'setCompanyList',
      'setHs2List',
			'setDomesticCompanyList',
			'setShippingCompanyList',
      'setInspectionCompanyList',
      'clearRlAddDialogList'
		])
	},
	computed: {
    dom_haul: {
      get: function () {
        if (this.dom_haul_show || this.entry.dom_haul_cost_cc || this.entry.dom_haul_cost || this.entry.dom_haul_company || this.entry.dom_haul_booked || this.entry.dom_haul_date) {
          return true
        } else {
          return false
        }
      },
      set: function (newValue) {
        if (newValue === false) {
          this.dom_haul_show = false
          this.entry.dom_haul_cost_cc = null
          this.entry.dom_haul_cost = null
          this.entry.dom_haul_company = null
          this.entry.dom_haul_booked = 0
          this.entry.dom_haul_date = null
        } else {
          this.dom_haul_show = true
        }
      }
    },
    int_ship: {
      get: function () {
        if (this.int_ship_show || this.entry.int_ship_cost_cc || this.entry.int_ship_cost || this.entry.int_ship_company || this.entry.int_ship_booked || this.entry.int_ship_date) {
          return true
        } else {
          return false
        }
      },
      set: function (newValue) {
        if (newValue === false) {
          this.int_ship_show = false
          this.entry.int_ship_cost_cc = null
          this.entry.int_ship_cost = null
          this.entry.int_ship_company = null
          this.entry.int_ship_booked = 0
          this.entry.int_ship_date = null
        } else {
          this.int_ship_show = true
        }
      }
    },    
    getCompanyListCalc() {
      if (this.entry.entry_type_id) {
        return this.getCompanyList.filter(x => x.entry_type_id === this.entry.entry_type_id).map(x => { return x.coll_dest_company })
      } else {
        return this.getCompanyList.map(x => { return x.coll_dest_company })
      }
    },
    getCompanyCountryCalc() {     
      if (this.entry.entry_type_id && this.entry.coll_dest_company) {
        const companyCountry = this.getCompanyList.filter(x => x.entry_type_id === this.entry.entry_type_id && x.coll_dest_company === this.entry.coll_dest_company).map(x => { return this.getCountryByCode(x.coll_dest_country) })
        
        if (companyCountry.length > 0) {
          const divider = {divider: true}
          return companyCountry.concat(divider, this.getCountryList)
        }
      }       
      return this.getCountryList
    },
    getCompanyCityCalc() {
      if (this.entry.entry_type_id && this.entry.coll_dest_company && this.entry.coll_dest_country) {
        return this.getCompanyList.filter(x => x.entry_type_id === this.entry.entry_type_id && x.coll_dest_company === this.entry.coll_dest_company && x.coll_dest_country === this.entry.coll_dest_country).map(x => { return x.coll_dest_city })
      }
    },
    getCompanyAddressCalc() {
      if (this.entry.entry_type_id && this.entry.coll_dest_company && this.entry.coll_dest_country && this.entry.coll_dest_city) { 
        return this.getCompanyList.filter(x => x.entry_type_id === this.entry.entry_type_id && x.coll_dest_company === this.entry.coll_dest_company && x.coll_dest_country === this.entry.coll_dest_country && x.coll_dest_city === this.entry.coll_dest_city).map(x => { return x.coll_dest_address })
      }
    },
    getCompanyContactCalc() {
      if (this.entry.entry_type_id && this.entry.coll_dest_company && this.entry.coll_dest_country && this.entry.coll_dest_city && this.entry.coll_dest_address) {
        return this.getCompanyList.filter(x => x.entry_type_id === this.entry.entry_type_id && x.coll_dest_company === this.entry.coll_dest_company && x.coll_dest_country === this.entry.coll_dest_country && x.coll_dest_city === this.entry.coll_dest_city && x.coll_dest_address === this.entry.coll_dest_address).map(x => { return x.coll_dest_contact_name })
      }
    },
    getHaulageCompanyCalc() {
      if (this.entry.entry_type_id) {
        return this.getDomesticCompanyList.filter(x => x.entry_type_id === this.entry.entry_type_id).map(x => { return x.dom_haul_company })
      } else {
        return this.getDomesticCompanyList.map(x => { return x.dom_haul_company })
      }
    },
    getShippingCompanyCalc() {
      if (this.entry.entry_type_id) {
        return this.getShippingCompanyList.filter(x => x.entry_type_id === this.entry.entry_type_id).map(x => { return x.int_ship_company })
      } else {
        return this.getShippingCompanyList.map(x => { return x.int_ship_company})
      }
    },
    getHs2ListCalc(){
      if (this.entry.entry_type_id) {
        return this.getHs2List.filter(x => x.entry_type_id === this.entry.entry_type_id).map(x => { return x.hs2 })
      } else {
        return this.getHs2List.map(x => { return x.hs2 })
      }
    },
    getInspectionCompanyCalc() {
      if (this.entry.entry_type_id) {
        return this.getInspectionCompanyList.filter(x => x.entry_type_id === this.entry.entry_type_id).map(x => { return x.insp_company })
      } else {
        return this.getInspectionCompanyList.map(x => {return x.insp_company})
      }
    },
    ...mapGetters([     
      'getUser',
      'getRlEntry',
      'getRlEditDialog',
      'getEntryTypeList',
      'getMaterialList',
      'getIncotermList',
      'getGradeList',
      'getCountryList',
      'getCurrencyList',
      'getUnitOfMeasureList',
      'getRlDialogRules',
      'getDomesticCompanyList',
      'getShippingCompanyList',
      'getHs2List',
      'getInspectionCompanyList',
      'getCompanyList',
      'getRlEntryAddDialogView2',		
      'getRlAddDialog',
      'getRlAddDialogList',    
    ])
  }
}
